import { environment } from '../../../environments/environment';

const API_BASE_URL = environment.apiUrl;

export const ApiEndpoints = {
  auth: `${API_BASE_URL}/auth`,
  authRefresh: `${API_BASE_URL}/auth/refresh`,
  userProfile: `${API_BASE_URL}/user/profile`,
  userProfileImage: `${API_BASE_URL}/user/profile-image`,
  users: `${API_BASE_URL}/users`,
  changePassword: `${API_BASE_URL}/auth/change-password`,
  administratives: `${API_BASE_URL}/administratives`,
  professors: `${API_BASE_URL}/professors`,
  professorGroups: `${API_BASE_URL}/professors/me/groups`,
  professorGradeSheets: `${API_BASE_URL}/professors/me/grade-sheets`,
  professorSchedules: `${API_BASE_URL}/professors/me/schedules`,
  communityAdministratives: `${API_BASE_URL}/administratives`,
  communityProfessors: `${API_BASE_URL}/professors`,
  communityStudents: `${API_BASE_URL}/students`,
  moodleAccounts: `${API_BASE_URL}/moodle-accounts`,
  studyPlans: `${API_BASE_URL}/study-plans`,
  subjects: `${API_BASE_URL}/subjects`,
  periods: `${API_BASE_URL}/periods`,
  students: `${API_BASE_URL}/students`,
  studentDocuments: `${API_BASE_URL}/student-documents`,
  studentPayments: `${API_BASE_URL}/payments/student`,
  preRegistrations: `${API_BASE_URL}/pre-registrations`,
  preRegistrationsExport: `${API_BASE_URL}/pre-registrations/export`,
  documentTypes: `${API_BASE_URL}/document-types`,
  academicEnrollments: `${API_BASE_URL}/academic-enrollments`,
  academicRecords: `${API_BASE_URL}/academic-records`,
  notifications: `${API_BASE_URL}/notifications`,
  auditLogs: `${API_BASE_URL}/audit-logs`,
  dashboardSummary: `${API_BASE_URL}/dashboard/summary`,
  dashboardGrades: `${API_BASE_URL}/dashboard/grades`,
  academicCalendar: `${API_BASE_URL}/academic-calendar`,
  payments: `${API_BASE_URL}/payments`,
  paymentReferences: `${API_BASE_URL}/payment-references`,
  paymentConcepts: `${API_BASE_URL}/payment-concepts`,
  paymentConceptGroups: `${API_BASE_URL}/payment-concept-groups`,
  paymentPlans: `${API_BASE_URL}/payment-plans`,
  paymentPlanInstallments: `${API_BASE_URL}/payment-plan-installments`,
  scholarships: `${API_BASE_URL}/scholarships`,
  groupCohorts: `${API_BASE_URL}/group-cohorts`,
  groups: `${API_BASE_URL}/groups`,
  gradeSheets: `${API_BASE_URL}/grade-sheets`,
  gradeCorrectionRequests: `${API_BASE_URL}/grade-correction-requests`,
  extraordinaryPeriods: `${API_BASE_URL}/extraordinary-periods`,
  groupSchedules: `${API_BASE_URL}/group-schedules`,
  waitlist: `${API_BASE_URL}/waitlist`,
  enrollments: `${API_BASE_URL}/enrollments`,
  groupEnrollments: `${API_BASE_URL}/enrollments/group`,
  cohortEnrollments: `${API_BASE_URL}/enrollments/cohort`,
  rostersExport: `${API_BASE_URL}/rosters/export`,
  financialSummaryReport: `${API_BASE_URL}/financial-reports/summary`,
  accountsReceivableReport: `${API_BASE_URL}/financial-reports/accounts-receivable`,
  studentStatementReport: `${API_BASE_URL}/financial-reports/students`,
  mePermissions: `${API_BASE_URL}/me/permissions`,
  roles: `${API_BASE_URL}/roles`,
  availablePermissions: `${API_BASE_URL}/permissions/available`,
} as const;

/** Parameterized endpoint builders. Kept separate so `ApiEndpoints` stays a flat map of strings. */
export const ApiRoutes = {
  extraordinaryPeriodRequests: (publicId: string): string =>
    `${API_BASE_URL}/extraordinary-periods/${encodeURIComponent(publicId)}/requests`,
  rolePermissions: (roleName: string): string =>
    `${API_BASE_URL}/roles/${encodeURIComponent(roleName)}/permissions`,
  userRoles: (userPublicId: string): string =>
    `${API_BASE_URL}/users/${encodeURIComponent(userPublicId)}/roles`,
  userRole: (userPublicId: string, roleName: string): string =>
    `${API_BASE_URL}/users/${encodeURIComponent(userPublicId)}/roles/${encodeURIComponent(roleName)}`,
  moodleAccountPassword: (userPublicId: string): string =>
    `${API_BASE_URL}/moodle-accounts/${encodeURIComponent(userPublicId)}/password`,
} as const;
